export enum DocumentVatIssueMode {
    VatPayer = 'VatPayer',
    NonVatPayer = 'NonVatPayer'
}